module.exports = __webpack_public_path__ + "img/shoplogo.de0c1cfd.svg";